import React, { useCallback } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import type { VoucherDisplayConfigVoucher } from 'api/promo'
import VoucherDetailsContent from './VoucherDetailsContent'

type VoucherConditionResult = NonNullable<App.PublicVoucher['conditions']>[number]['rewardGroup']['results'][number]

type VoucherAnyType = App.PublicVoucher | App.PublicVoucherCalculated | VoucherDisplayConfigVoucher

type Props = {
  title: string
  voucher: VoucherAnyType
  conditionResults?: Array<VoucherConditionResult>
}

function VoucherDetailsModal({ title, voucher, conditionResults }: Props) {
  const modalElement = useModalElementContext()

  const onClose = useCallback(() => {
    modalElement.resolve(undefined)
  }, [modalElement])

  return <ModalBase size="L">
    <ModalHeader
      title={title}
      onCloseButtonClick={onClose}
    />
    <ModalBody>
      <ModalContent>
        <VoucherDetailsContent voucher={voucher} conditionResults={conditionResults} />
      </ModalContent>
    </ModalBody>
  </ModalBase>
}

export default VoucherDetailsModal
